import React from 'react';
import { Field } from 'redux-form';
import { trim } from 'lodash';

// @ts-ignore
import { FormGroupSelect } from 'components/Form';

import { EnvironmentItem } from 'scenes/ProjectSettings/scenes/Environments/EnvironmentsList/Environment/types';
import TextFieldWrapperForReduxForm from './TextFieldWrapperForReduxForm';

import { SForm } from './styled';

type Props = {
  environmentsList: EnvironmentItem[];
  change: (fieldName: string, value: string) => void;
};

const UploadProjectModalForm = ({ environmentsList, change }: Props) => {
  const deploymentEnvironmentOptions = environmentsList.map(
    ({ url, id, name }) => ({
      label: `${url} (${name})`,
      value: id,
    }),
  );

  const handleEnvironmentChange = (e: Event, newValue: string) => {
    const applicationName =
      environmentsList.find(e => e.id === newValue)?.app_name || '';
    change('applicationName', applicationName);
  };

  return (
    <SForm>
      <Field
        disabled
        component={TextFieldWrapperForReduxForm}
        data-test="application-name"
        label="Application Name"
        name="applicationName"
      />

      <Field
        component={FormGroupSelect}
        data-test="deployment-environment"
        label="Deployment Environment"
        name="deploymentEnvironment"
        options={deploymentEnvironmentOptions}
        placeholder="Select a deployment environment"
        onChange={handleEnvironmentChange}
      />

      <Field
        component={TextFieldWrapperForReduxForm}
        data-test="password"
        label="Password"
        name="password"
        normalize={trim}
        type="password"
      />

      <Field
        component={TextFieldWrapperForReduxForm}
        label="Description (Optional)"
        name="description"
      />
    </SForm>
  );
};

export default UploadProjectModalForm;
